<footer>
  <div class="footer-wrapper">
    <a class="text" id="name-text" href="https://www.osd.at/" target="_blank">
      &copy; 2021 ÖSD - Österreichisches Sprachdiplom Deutsch
    </a>
    <div class="text" id="imprint-text" aria-label="Impressum" [routerLink]="['/imprint']">
      <mat-label>Impressum</mat-label>
    </div>


    <div class="text" aria-label="Info" [routerLink]="['/info']">
      <mat-label>Info</mat-label>
    </div>


    <div class="text" aria-label="Kontakt" [routerLink]="['/contact']">
      <mat-label>Kontakt</mat-label>
    </div>
  </div>
</footer>
